<form [formGroup]="form" class="row">
    <!-- Caso autorizacionTransaccion  -->
    <div class="col-12" >
       <!-- <mat-form-field appearance="outline" class="col-6">
           <mat-label>Tipo Documento</mat-label>
           <mat-select  formControlName="tipo_docuemnto"  >
             <mat-option  *ngFor="let tipo of tipo_validaciones"  [value]="tipo">
               {{tipo}}
             </mat-option>
           </mat-select>
         </mat-form-field> -->
         <mat-form-field  appearance="outline" class="col-6">
            <mat-label>Tipo Documento</mat-label>
            <input formControlName="tipo_docuemnto"  matInput>
          </mat-form-field>
          <mat-form-field  appearance="outline" class="col-6">
            <mat-label>Ente Emisor del Documento</mat-label>
            <input formControlName="ente"  matInput>
          </mat-form-field>
       <mat-form-field  appearance="outline" class="col-6">
         <mat-label>C.I. de la persona</mat-label>
         <input formControlName="ci_persona"  matInput>
       </mat-form-field>
       <mat-form-field  appearance="outline" class="col-6">
         <mat-label>Nombres y Apellidos Persona</mat-label>
         <input formControlName="nombre_apellido"  matInput>
       </mat-form-field>
     </div>
</form>
